import { render, staticRenderFns } from "./stockAddrer.vue?vue&type=template&id=03c2972d"
import script from "./stockAddrer.vue?vue&type=script&lang=js"
export * from "./stockAddrer.vue?vue&type=script&lang=js"
import style0 from "./stockAddrer.vue?vue&type=style&index=0&id=03c2972d&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports